import { render, staticRenderFns } from "./WysiwygEditor.vue?vue&type=template&id=350d8166&"
import script from "./WysiwygEditor.vue?vue&type=script&lang=js&"
export * from "./WysiwygEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports